<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path stroke="currentColor" stroke-width="2" d="M1 8h14M8 1v14" />
  </svg>
</template>
